export default {
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
};



// WEBPACK FOOTER //
// ./src/reducers/settings/types.js